import React, { SFC } from 'react'
import Provider from '../../../types/Provider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.css'

interface Props {
  enabled: boolean;
  first_name: string;
  last_name: string;
  provider_data: Array<Provider>;
  role: string;
  role_id: number;
  status: string;
  user_id: number;
  onSendEmail: (e: any) => void;
  openEditUserModal: (e: any) => void;
}

const UserRow: SFC<Props> = (props) => {
  const { first_name, last_name, provider_data, role, role_id, status, enabled, onSendEmail, openEditUserModal } = props
	
  let providerList = ''
  if(provider_data !== undefined)
    provider_data.forEach((provider, index)=>{
      if(index===0)
        providerList = provider.provider_name
      else
        providerList += ', '+provider.provider_name
    })

  return (
    <div className="userRow">
      <div className="userRowContainer">
        <div className="userRowTextContainer">
          <FontAwesomeIcon icon={['fas', 'user-circle']} size="3x" className="userRowIcon" />
          <div className="userRowText">
            <span className="userRowName" onClick={openEditUserModal}>{first_name+' '+last_name}</span>
            <div className="userRowData">
              <div>User role: <span className="userRowBold">{role}</span></div>
              <div className="userRowItem">|</div>
              <div className="userRowItem" style={{ maxWidth: 1330 }}>Access Group: 
                {role_id===4?(
                  <span className="userRowBold"> {providerList}</span>
                ):(
                  <span className="userRowBold"> All</span>
                )}
              </div>
              <div className="userRowItem">|</div>
              <div className="userRowItem">Status: <span className="userRowBold">{enabled?(status==='created'?'Pending':'Enabled'):'Disabled'}</span></div>
            </div>
          </div>
        </div>
        <div className="userRowEditContainer">
          {enabled?(status==='created'?(
            <div style={{marginRight:20}} onClick={onSendEmail}>
              <span className="userRowEditButton">Send Activation Mail</span>
              <FontAwesomeIcon
                icon={['fas', 'external-link-alt']}
                size="lg"
                className="userRowEditIcon"
              />
            </div>
          ):(
            null
          )):(
            null
          )}
          <div onClick={openEditUserModal}>
            <span className="userRowEditButton">View / Edit User Profile</span>
            <FontAwesomeIcon
              icon={['fas', 'chevron-circle-right']}
              size="lg"
              className="userRowEditIcon"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default UserRow
